import { useCreation } from 'ahooks'
import { ConfigProvider, Table } from 'antd'
import { createStyles } from 'antd-style'

import { paginationConfig } from '../../config/pagination'
import { GenericalRecord } from '../../types/utilities'

import { useColumns } from './hooks/useColumns'
import { useSummary } from './hooks/useSummary'
import { ProTableProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  table: {
    [`& .${prefixCls}-table-thead >tr>th`]: {
      whiteSpace: 'nowrap'
    },
    // 无边框时隐藏表头的边框
    [`&:not(.is-bordered) .${prefixCls}-table-thead>tr>th::before`]: {
      display: 'none'
    }
  }
}))

export const ProTable = <T extends GenericalRecord, S extends GenericalRecord>({
  ref,
  context,
  /* -------------------------------------------------------------------------- */
  /*                              Antd Table Props                              */
  /* -------------------------------------------------------------------------- */
  className,
  columns,
  cellEmptyText = '-',
  expandable,
  rowSelection,
  summary,
  summaryData,
  pagination,
  bordered,
  ...restProps
}: ProTableProps<T, S>) => {
  const enhancedColumns = useColumns(columns, cellEmptyText, context)

  const defaultSummary = useSummary(
    summaryData,
    columns,
    !!expandable,
    !!rowSelection
  )

  const { componentSize } = ConfigProvider.useConfig()

  const mergingPagination = useCreation(
    () =>
      pagination === false
        ? false
        : ({
            size: componentSize,
            ...paginationConfig,
            ...pagination
          } as const),
    [pagination]
  )

  const { cx, styles } = useStyles()
  return (
    <Table
      ref={ref}
      bordered={bordered}
      className={cx({ 'is-bordered': bordered }, styles.table, className)}
      columns={enhancedColumns}
      expandable={expandable}
      pagination={mergingPagination}
      rowSelection={rowSelection}
      size='small'
      summary={summary ?? defaultSummary}
      {...restProps}
    />
  )
}
